import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import * as moment from 'moment';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import { ConfigurationService } from 'src/app/services/core/configuration/configuration.service';
import { CredentialService } from 'src/app/services/core/credential/credential.service';
import { UploadService } from 'src/app/services/core/documents/upload.service';
import { SpaceTypeService } from 'src/app/services/core/spaceTypes/space-type.service';
import { vehicleVerificationLabels } from 'src/app/utils/common.utils';
import { addressValidator } from 'src/app/utils/custom-validators';
import { imageProcessing, ImageSnippet } from 'src/app/utils/image-processing-utils';
import { sweetAlert } from 'src/app/utils/swal';
import { getFileNameFromUrl, onTimeChange, uploadDocumentImages } from 'src/app/utils/utils.common';
@UntilDestroy()
@Component({
  selector: 'app-add-vehicle',
  templateUrl: './add-vehicle.component.html',
  styleUrls: ['./add-vehicle.component.css']
})
export class AddVehicleComponent implements OnInit {
  submitted = false;
  vehicleForm!: FormGroup
  companyId: any;
  vehicleId: any;
  spaceTypes: any;
  selectedSpaceTypes = [];
  selectedFile: ImageSnippet | null = null;
  verification:any = false;
  rejectionReasons: any = {};
  user:any;
  constructor(
    private uploadService: UploadService,
    private configurationService: SpaceTypeService,
    private cedentialService: CredentialService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private sharedDataService: SharedDataService
    
  ) { }

  ngOnInit(): void {

  

    this.vehicleForm = this.fb.group({
      description: ['', Validators.required],
      vin: ['', Validators.required],
      licensePlateNumber: ['', Validators.required],
      year: ['', Validators.required],
      make: ['', Validators.required],
      model: ['', Validators.required],
      color: ['', Validators.required],
      isActive: [false, Validators.required],
      spaceType: ['', Validators.required],
      garageAddress: this.fb.group({
        name: ['', Validators.required],
        coords: [[]],
        city: ['', Validators.required],
        state: ['', Validators.required]
      }, { validators: addressValidator() }),
      serviceAreas: [''],
      images: this.fb.group({
        registration: [],
        inspectionReport: [],
        vehicle: [],
        back: [],
        left: [],
        right: [],
      }),
      dates: this.fb.group({
        registrationDate: [''],
        registrationExpireDate: [''],
        inspectionDate: [''],
        inspectionExpireDate: ['']
      }),
      company: ['']
    });
    
    this.vehicleId = this.route.snapshot.params['vehicleId'];
    if (this.vehicleId) {
      this.getVehicleById();
    }
    
    this.getUser();
    this.getSpaceTypes();
    this.validateLinkedDates(this.datesForm, 'registrationDate', 'registrationExpireDate');
    this.validateLinkedDates(this.datesForm, 'inspectionDate', 'inspectionExpireDate');
  }

  getUser() {
    this.sharedDataService
    .getUser()
    .pipe(untilDestroyed(this))
    .subscribe(user => {
      if (user) {
        this.user = user;
        this.companyId = this.user.company.id
      }
    });
  }

  validateLinkedDates(formGroup: FormGroup, startCtrl: string, endCtrl: string) {
    formGroup.valueChanges.subscribe(values => {
      const start = values[startCtrl];
      const end = values[endCtrl];

      const startControl = formGroup.get(startCtrl);
      const endControl = formGroup.get(endCtrl);

      if (start && end && new Date(start) >= new Date(end)) {
        endControl?.setErrors({ dateMismatch: true });
      } else {
        if (endControl?.hasError('dateMismatch')) {
          endControl.setErrors(null);
        }
      }
    });
  }

  get form() {
    return this.vehicleForm.controls;
  }

  get imagesForm() {
    return this.vehicleForm.controls.images as FormGroup;
  }

  get garageAddressForm() {
    return this.vehicleForm.controls.garageAddress as FormGroup
  }

  get datesForm() {
    return this.vehicleForm.controls.dates as FormGroup;
  }

  onSave() {
    // debugger
    this.submitted = true;
    if (this.vehicleForm.invalid) return;
    this.vehicleForm.patchValue({
      company : this.companyId,
      // spaceType: this.selectedSpaceTypes
    })
    let payload = this.vehicleForm.value;

    // delete payload.dates.preInspectionReport,
      // delete payload.dates.preRegistration,

    if (this.vehicleId) {
      sweetAlert(
        'Confirm Update',
        'Do you want to update and request review, or just update?',
        'question',
        'Update & Request Review',
        'Update'
      ).then((result: any) => {
        if (result.value) {
          this.saveVehicle(payload, true);
        } else {
          this.saveVehicle(payload, false);
        }
      });
    } else {
      this.saveVehicle(payload, false);
    }
  }

  private saveVehicle(payload: any, alsoRequestReview: boolean) {
    this.cedentialService.saveVehicle(this.vehicleId, payload).pipe(untilDestroyed(this)).subscribe(async (data: any) => {
        if (data) {
          if (alsoRequestReview) {
            await this.sendInvalidFields();
          }
          this.router.navigateByUrl(`/vehicles`);
        }
      },
      (err) => {
             sweetAlert("Error", err, "error", "Ok");
          }
    )
  }

  getSpaceTypes() {
    const queryparams = {
      isActive: true,
      limit:9999
    }
    this.configurationService.getPicker(queryparams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results ) {
        this.spaceTypes = data.results;
      }
    })
  }

  getVehicleById() {
    this.cedentialService.getVehicleById(this.vehicleId).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.vehicleForm.patchValue({
          ...data,
        })
        if(data.validationFlags){
          this.verification = data.validationFlags;
        }
        this.rejectionReasons = data.rejectionReasons || {};
        this.selectedSpaceTypes = data.spaceTypes

      }
    })
  }

  onSelectAddress(place: any): void {
    const selectedAddress = place.address_components;
    const city = selectedAddress.find((data: any) =>
      data.types.includes('locality') || data.types.includes('administrative_area_level_2')
    );
    const cityName = city ? city.long_name : '';
    const state = selectedAddress.find((data: any) =>
      data.types.includes('administrative_area_level_1')
    );
    const stateName = state ? state.long_name : '';
    this.vehicleForm.patchValue({
      garageAddress: {
        city: cityName,
        state: stateName,
        name: place.formatted_address,
        coords: [
          place.geometry.location.lng(),
          place.geometry.location.lat()
        ]
      }
    });
  }

  deleteFile(formControl: AbstractControl<any, any> | null, fileInput: HTMLInputElement) {
    formControl?.setValue(null); // Safely calls setValue if formControl is not null
    if (fileInput) {
      fileInput.value = '';
    }
  }

  onInspectionReportChange(evt: any) {
    this.datesForm.get('inspectionReport')?.setValue(moment(evt).toISOString());
  }

  onRegistrationChange(evt: any) {
    this.datesForm.get('registration')?.setValue(moment(evt).toISOString());
  }

  // ---Generic Method for upload documents

  uploadDocumentImages(documents: any, formControl: AbstractControl<any, any> | null) {
    uploadDocumentImages(documents, formControl, this.uploadService)
  }

  getFileName(url: any) {
    return getFileNameFromUrl(url);
  }

  getRejectionReason(section: string, controlName: string): string {
    return this.rejectionReasons?.[section]?.[controlName]?.reason || '';
  }

  // Generic Method for select datetime

  onDateChange(controlName: AbstractControl<any, any> | null) {
    onTimeChange(controlName)
    }


  getInvalidFields(): string[] {
    const formValues = this.verification;
    const labels: string[] = [];
    this.traverseForm(formValues, vehicleVerificationLabels, labels);
    return labels;
  }

  traverseForm(values: any, labelMap: any, labels: string[], prefix: string = ''): void {
    Object.keys(values).forEach(key => {
      if (typeof values[key] === 'object' && values[key] !== null) {
        // Check if labelMap[key] is an object, recursively call the function
        if (typeof labelMap[key] === 'object') {
          this.traverseForm(values[key], labelMap[key], labels, prefix);
        } else {
          this.traverseForm(values[key], labelMap[key], labels, prefix + labelMap[key] + ' - ');
        }
      } else if (values[key] === false) {
        labels.push(prefix + (labelMap[key] || key));
      }
    });
  }

  async sendInvalidFields(): Promise<void> {
    const invalidFields = this.getInvalidFields();
    if (invalidFields.length > 0) {
      try {
        const data = await this.cedentialService.requestReviewVehicle(this.vehicleId, invalidFields).toPromise();
        if (data) {
          console.log("Review request sent successfully.");
          // this.onCloseModal();
        }
      } catch (err) {
        sweetAlert("Error", err, "error", "Ok");
      }
    }
  }

  onChangeGarageOriginAddress() {
    this.vehicleForm.patchValue({
      garageAddress: {
        coords: '',
        city: '',
        state: '',
      }
    });
  }

}